// extracted by mini-css-extract-plugin
export default {"container":"ZiswM","spinner":"dujnF","image":"yzkpG"};